import { useState, useEffect } from 'react';

import { Button, Modal, Table, Typography, Tag } from "antd";

import { ErrorResponse } from 'utils/types';
import { formatDate } from 'utils/helpers';
import { Color, StatusCode } from 'utils/enums';
import notifier from 'utils/notifier';
import { ORGANIZATION_NAME, companyIdOptions } from 'utils/objects';

import AuthorizationDetailModal from 'components/Eligibility/MemberEligibilityDetailTables/AuthorizationHistoryTable/AuthorizationDetailModal';

import DuplicateAuthsModalProps from './Proptypes';

const { Title } = Typography;

const DuplicateAuthsModal = (props: DuplicateAuthsModalProps) => {
  const [isAuthDetailModalVisible, setIsAuthDetailModalVisible] = useState(false);
  const [authorizationDetailModalDataSource, setAuthorizationDetailModalDataSource] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [companyName, setCompanyName] = useState('');

  const duplicateAuthsModalColumns = [
    {
      title: "Auth Number",
      key: "authNo",
      dataIndex: "authNo",
      render: (_: number, record: any) => <Button type='link' onClick={() => authDetailModal(record.authNo, record.companyId)}>{record.authNo}</Button>
    },
    {
      title: "Requested Date",
      key: "reqDate",
      dataIndex: "reqDate",
      render: (_: number, record: any) => formatDate(record.reqDate, 'MM/DD/YYYY')
    },
    {
      title: "Expiry Date",
      key: "exprDate",
      dataIndex: "exprDate",
      render: (_: number, record: any) => formatDate(record.exprDate, 'MM/DD/YYYY')
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (_: number, record: any) => {
        return (
          <>
            { StatusCode[record.status] === 'APPROVED' && <Tag color={Color.APPROVED}>APPROVED</Tag> }
            { StatusCode[record.status] === 'MODIFIED' && <Tag color={Color.MODIFIED}>MODIFIED</Tag> }
            { StatusCode[record.status] === 'DEFERRED' && <Tag color={Color.DEFERRED}>DEFERRED</Tag> }
            { StatusCode[record.status] === 'CANCELLED' && <Tag color={Color.CANCELLED}>CANCELLED</Tag> }
            { StatusCode[record.status] === 'EXPIRED' && <Tag color={Color.EXPIRED}>EXPIRED</Tag> }
            { StatusCode[record.status] === 'DENIED' && <Tag color={Color.DENIED}>DENIED</Tag>}
            { StatusCode[record.status] === 'PENDED' && <Tag color={Color.PENDED}>PENDED</Tag>}
            { StatusCode[record.status] === 'REQUESTED' && <Tag style={{ "color": Color.REQUESTED_TEXT}}  color={Color.REQUESTED}>REQUESTED</Tag> }
            { StatusCode[record.status] === 'SYSTEM_HOLD' && <Tag style={{ "color": Color.SYSTEM_HOLD_TEXT}} color={Color.SYSTEM_HOLD}>SYSTEM HOLD</Tag> }
          </>
        );
      }
    },
  ];

  useEffect(() => {
    if (props.isDuplicateAuthsModalVisible) {

      const companyInfo = companyIdOptions.find((val: { companyId: string | null; }) => val.companyId === sessionStorage.getItem('ipa'));
      if (companyInfo && companyInfo.name) setCompanyName(companyInfo!.name);
    }
  }, [props.isDuplicateAuthsModalVisible]);

  const isAuthDetailModalVisibleHandler = () => {
    setIsAuthDetailModalVisible(false);
  }

  const okCancel = () => {
    props.isDuplicateAuthsModalVisibleHandler();
  }

  const onConfirm = () => {
    props.isDuplicateAuthsModalVisibleHandler();
    props.onSubmitAlertCallHandler();
  }

  const authDetailModal = (authNo: string, companyId: string) => {
    props.getPortalAuth(authNo, companyId, parseInt(sessionStorage.getItem('user_role')!))
    .then((data: any) => {
      setAuthorizationDetailModalDataSource(data);
      setIsAuthDetailModalVisible(true);
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });

    props.getAttachInfo(authNo, companyId)
      .then((response: any) => {
        setAttachments(response);
      }).catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  return (
    <>
      <Modal
        visible={props.isDuplicateAuthsModalVisible}
        maskClosable={false}
        width="1000px"
        footer={[
          <>
            <Button
              onClick={okCancel}
            >
            Cancel Auth Submission
            </Button>,
            <Button
              type="primary"
              onClick={onConfirm}
            >
              Submit Authorization
            </Button>
            <div className="row pt-2">
              <div className="col-lg-24 col-md-24">
                <p className="float-left pt-2">&copy; {ORGANIZATION_NAME}, Inc., All Rights Reserved</p>
              </div>
            </div>
          </>
        ]}
        onCancel={okCancel}
      >
        <div className="container">
          <Title level={3}>
          <div>Potential Duplicate Authorizations</div>
          </Title>
        </div>
        <Table
          columns={duplicateAuthsModalColumns}
          dataSource={props.duplicateAuthModalDataSource}
          pagination={{ position: ["bottomCenter"], hideOnSinglePage: true }}
        />
      </Modal>

      <AuthorizationDetailModal
        attachments={attachments}
        authorizationDetailModal={authorizationDetailModalDataSource}
        isModalVisible={isAuthDetailModalVisible}
        isModalVisibleHandler={isAuthDetailModalVisibleHandler}
        isAuthHistoryModalVisibleHandler={props.isDuplicateAuthsModalVisibleHandler}
        isFetchingAuth={props.isFetchingAuth}
      />
    </>
  );
};

export default DuplicateAuthsModal;
